import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from '../globals';
declare var $, unescape, escape: any;

@Component({
    selector: 'app-welcome',
    templateUrl: './welcome.component.html',
    styleUrls: ['./welcome.component.css']
})
export class WelcomeComponent implements OnInit {

    constructor(public globals: Globals, private router: Router) { }

    ngOnInit() {
        this.globals.pageTitle = '- Welcome';
        $('body').addClass('height_100');
        localStorage.removeItem('UserId');
        localStorage.removeItem('ParentId');
        localStorage.removeItem('rate1');
        localStorage.removeItem('rate2');
        localStorage.removeItem('rate3');
        localStorage.removeItem('rate4');
        localStorage.removeItem('rate5');
        localStorage.removeItem('rate6');
        localStorage.removeItem('rate7');
        localStorage.removeItem('rate8');
        localStorage.removeItem('rate9');
        localStorage.removeItem('Delivering');
        localStorage.removeItem('Receiving');

        var currentYear = (new Date()).getFullYear();
        $("#footer_year").html(currentYear);

        const body = document.querySelector('body');
        body.style.setProperty('--screen-height', $(window).height() - 40 + "px");

        $('body').tooltip({
            selector: '[data-toggle="tooltip"], [title]:not([data-toggle="popover"])',
            trigger: 'hover',
            container: 'body'
        }).on('click mousedown mouseup', '[data-toggle="tooltip"], [title]:not([data-toggle="popover"])', function () {
            $('[data-toggle="tooltip"], [title]:not([data-toggle="popover"])').tooltip('destroy');
        });

        checkCookie_eu();

        function checkCookie_eu() {

            var consent = getCookie_eu("cookies_consent");

            if (consent == null || consent == "" || consent == undefined) {
                // show notification bar
                $('#cookie_directive_container').show();
            }

        }

        function setCookie_eu(c_name, value, exdays) {

            var exdate = new Date();
            exdate.setDate(exdate.getDate() + exdays);
            var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
            document.cookie = c_name + "=" + c_value + "; path=/";

            $('#cookie_directive_container').hide();
        }


        function getCookie_eu(c_name) {
            var i, x, y, ARRcookies = document.cookie.split(";");
            for (i = 0; i < ARRcookies.length; i++) {
                x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
                y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
                x = x.replace(/^\s+|\s+$/g, "");
                if (x == c_name) {
                    return unescape(y);
                }
            }
        }


    }

    close_cookie() {
        var exdate = new Date();
        exdate.setDate(exdate.getDate() + 30);
        var c_value = escape(1) + ((30 == null) ? "" : "; expires=" + exdate.toUTCString());
        document.cookie = "cookies_consent =" + c_value + "; path=/";

        $('#cookie_directive_container').hide();
    }

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/OESS_LFB_V2demo/src/app/welcome/welcome.component.ts